import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';
import "firebase/compat/storage";
import "firebase/compat/analytics";

const firebaseConfig = {
    apiKey: "AIzaSyBpQ3CIUsEwPiJZa8R5Jum9XVDzGBZyWwA",
    authDomain: "honeycomb-studios.firebaseapp.com",
    projectId: "honeycomb-studios",
    storageBucket: "honeycomb-studios.appspot.com",
    messagingSenderId: "322880760956",
    appId: "1:322880760956:web:abd7b16aa63e71402eadf9"
  };

var firebaseApp = firebase.initializeApp(firebaseConfig);

var db = firebaseApp.firestore();
var storage = firebase.storage();
var auth = firebase.auth();
var storageRef = firebase.storage().ref();
var analytics = firebase.analytics();
var firebaseVars = {db, auth, storage, storageRef};

export default firebaseVars;